import { render, staticRenderFns } from "./NewsMenu.vue?vue&type=template&id=36ecf27c&scoped=true&"
import script from "./NewsMenu.vue?vue&type=script&lang=js&"
export * from "./NewsMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewsMenu.vue?vue&type=style&index=0&id=36ecf27c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ecf27c",
  null
  
)

export default component.exports